.option {
	display: flex;
	align-items: flex-start;
	gap: 8px;
	cursor: pointer;
}

.option[data-disabled] {
	opacity: 0.5;
	cursor: not-allowed;
}

.option[data-focus-visible] {
	outline: var(--focus-outline);
	border: 1px solid transparent;
}

.dot {
	width: 16px;
	height: 16px;
	border-radius: 50%;
	border: 1.4px solid var(--border-primary);
	background-color: var(--background-primary);
	flex-shrink: 0;
	position: relative;
	margin-top: 2px;
}

.option[data-selected] .dot {
	border-color: var(--background-secondary);
}

.option[data-selected] .dot::after {
	content: "";
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: var(--background-secondary);
}

.content {
	flex: 1;
	min-width: 0;
}
